import {useCallback, useEffect, useRef} from 'react';
import {useAppSelector} from '@/hooks/appHook';
import {getUser} from '@/store/user/user';
import pushyme from '@/services/Pushyme/Pushyme';
import {getLang} from '@/store/language/language';
import {PushymeMessage} from '@/interfaces/tabsInteraction';
import Notificator from '@/services/Pushyme/Notificator';
import {TabsInteractionType} from '@/constants/tabsInteraction';
import useActiveService from '@/hooks/useActiveService';

export const usePushyme = () => {
  const user = useAppSelector(getUser)
  const lang = useAppSelector(getLang)
  const lastToken = useRef<string | null>(null)
  const notificator = useRef<Notificator>()
  if (!notificator.current) {
    notificator.current = new Notificator()
  }

  const { setActiveChatId } = useActiveService()

  useEffect(() => {
    if (!user?.token) {
      return
    }
    if (lastToken.current !== user.token) {
      pushyme.updateToken(lang)
      lastToken.current = user.token
    } else {
      pushyme.changeLang(lang)
    }
  }, [lang, user?.token]);

  useEffect(() => {
    if (user?.token) {
      return
    }
    lastToken.current = null
  }, [user?.token]);

  const onPushMessage = useCallback((message: PushymeMessage) => {
    switch (message.type) {
      case 'new-message':
        setActiveChatId(message.jidFrom)
        break
    }
  }, [setActiveChatId])

  useEffect(() => {
    notificator.current?.addEventListener(TabsInteractionType.PushymeMessage, onPushMessage)
    return () => {
      notificator.current?.removeEventListener(TabsInteractionType.PushymeMessage, onPushMessage)
    }
  }, [onPushMessage]);
}

